import { Link } from 'ui/Link';
import styled, { css } from 'styled-components';
import Button, { StyledButton } from 'ui/Button/Button';
import {
    inputContainerMixin,
    InputContainerMixinProps
} from 'ui/Input/Input.styled';
import { TextL, TextM } from 'ui/Styled/Styled';
import { S as TableS } from 'ui/Table';
import Icon from 'ui/Icon/Icon';
import { themeable } from 'themes/utils';
import ButtonsContainerRow from 'ui/Button/ButtonContainerRow';
import { notDesktopMediaQuery } from 'utils/mediaQuery';
import { MainContainer } from 'components/Container/Container.styled';

export const Container = styled.div`
    min-height: 100%;
`;

export const Wrapper = styled.div`
    & ${MainContainer} {
        height: unset;
        min-height: 100%;
    }
`;

export const DatesRow = styled.div`
    display: flex;
    flex-flow: row;
    gap: 30px;
    width: 100%;
    margin: 15px 0;

    ${notDesktopMediaQuery(css`
        flex-flow: column;
        gap: 15px;
    `)}
`;

export const ButtonsRow = styled(ButtonsContainerRow)`
    margin-left: auto;
`;

export const DocumentRowLabel = styled(TableS.Cell)`
    font-weight: 500;
    font-size: 16px;
    text-align: left;
    padding-left: 30px;
    display: flex;
    flex-flow: row;
    gap: 8px;
    align-items: center;
    flex: 1;
`;

export const DocumentLockStatus = styled.div``;

export const DocumentRowButton = styled(TableS.Cell)`
    flex: unset;
    display: flex;
    flex-flow: row;
    gap: 16px;

    & ${StyledButton} {
        margin-left: auto;
    }

    & ${StyledButton} svg {
        margin-right: 0 !important;
    }
`;

export const DocumentObjectTitle = styled.div`
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
`;

export const DocumentObjectHeader = styled.header`
    padding: 0 30px;
`;

export const DocumentObjectDate = styled(TextM)`
    color: #abbbc2;
`;

export const DocumentSectionTitle = styled.div`
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    border-bottom: 2px solid #ffffff;
    padding-bottom: 4px;
    padding-left: 10px;
    margin-top: 46px;
    margin-bottom: 30px;
`;

export const DisciplinesContainer = styled.div`
    padding: 0 40px 30px;
    display: grid;
    gap: 4px;
`;

export const DisciplineRow = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: 1.5fr 3fr 1.5fr 2fr;
`;

export const DisciplineLabelsRow = styled(DisciplineRow)`
    text-align: center;
`;

export const AssignPayContainer = styled.div`
    margin: 50px 0 0;
    width: 100%;
    max-width: 405px;
    display: flex;
    flex-flow: column;
    gap: 16px;
    padding-bottom: 50px;
`;

export const AssignPayInner = styled.div`
    margin-bottom: 15px;
`;

export const CopyInputContainer = styled.div<InputContainerMixinProps>`
    ${inputContainerMixin}
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
`;

export const CopyInputLink = styled(Link)`
    text-decoration: underline;
`;

export const CopyInputIcon = styled(Icon)`
    cursor: pointer;
    padding: 8px;
    margin-right: -8px;
    color: ${themeable('primaryColor')};
    box-sizing: content-box;
`;

export const AssigmentPaidStatus = styled(TextL)<{ $paid?: boolean }>`
    color: ${({ $paid }) => themeable($paid ? 'success' : 'secondaryColor')};
    text-align: center;
    margin: 10px 0;
    font-weight: 400;
`;

export const RecipiencyDocumentsButton = styled(Button)`
    margin-top: 16px;
`;
